import { Component } from 'react'
import classNames from 'classnames'
import styles from './YTable.css'

import ReactTable from 'react-table'
import 'react-table/react-table.css'
import { Icon, Loader } from '@vzmi/shp_shared_compo'
import { DEFAULT_PAGINATION } from '../../constants/globalTypes'

class YTable extends Component {
  getWrappedInstance = () => {
    return this.table
  }

  render () {
    const { className, loading, ...props } = this.props
    const classes = classNames(
      styles.yTable,
      className
    )
    return (
      <div
        className={classes}
        data-role='y-table'
      >
        <ReactTable
          ref={r => (this.table = r)}
          minRows='1'
          sortable={false}
          resizable={false}
          defaultPageSize={DEFAULT_PAGINATION.perPage}
          showPagination
          pageText='頁數'
          ofText='之'
          rowsText='筆'
          loadingText='讀取中...'
          noDataText='查無資料'
          pageSizeOptions={[20, 25, 50]}
          previousText={(
            <Icon
              className={styles.paginationArrow}
              name='caret-left'
              size={18}
            />
          )}
          nextText={(
            <Icon
              className={styles.paginationArrow}
              name='caret-right'
              size={18}
            />
          )}
          LoadingComponent={() => (
            <Loader
              className={styles.tableLoader}
              loaded={!loading}
            />
          )}
          {...props}
        />
      </div>
    )
  }
}

export default YTable
